module.exports = __webpack_public_path__ + "site/img/index11zh.bf21cc89.png";